import "./App.scss";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Router } from "./Router";
import Dashboard from "../components/Dashboard";
import Header from "../components/Header";
import { trackPageview } from "../services/analyticsService";

export default function App() {

  const location = useLocation();
  const showHeader = location.pathname != "/";
  const showDashboard = location.pathname != "/" && location.pathname != "/leaderboard";

  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return (
    <>
      {showHeader && <Header />}
      {showDashboard && <Dashboard />}
      <Router key="R" />
    </>
  );
}
